konnyScript(function($){
    

    /* 주의사항 펼침 기능 */
    $('.smcrEvent .conWrap .notiBox .notiTit').click(function(){
        var notiBox = $(this).parent('.notiBox');
        notiBox.toggleClass('on');
    });

    var swiper = new Swiper("#smcr_swiper_slide1", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: '2.9%',
        scrollbar: {
            el:'#smcr_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el:'#smcr_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#smcr_swiper_slide1 .swiper-button-next',
            prevEl: '#smcr_swiper_slide1 .swiper-button-prev',
        },
    });
  
    var swiper = new Swiper("#smcr_swiper_slide2", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: '2.9%',
        scrollbar: {
            el:'#smcr_swiper_slide2 .swiper-scrollbar',
        },
        pagination: {
            el:'#smcr_swiper_slide2 .swiper-pagination',
        },
        navigation: {
            nextEl: '#smcr_swiper_slide2 .swiper-button-next',
            prevEl: '#smcr_swiper_slide2 .swiper-button-prev',
        },
    });

})